import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Image, Text } from '@blueprint/ui';
import { zooplaTheme as theme } from '@blueprint/theme';

export const FigureWrapper = styled.figure(
    css`
        margin: 0 0 ${theme.spacing['24px']} 0;

        ${Image} {
            margin: 0 0 ${theme.spacing['8px']} 0;
        }

        & + h2,
        & + h3 {
            margin-top: 0;
        }
    `
);

export const FigCaption = Text.withComponent('figcaption');
